<template>
  <DragPanel
    title="目录树"
    :closePanel="closePanel"
    :limitDragArea="limitDragArea"
    class="common-drag-panel">
    <div class="catalog-tree-box">
      <div
        class="common-card-tabs-box"
        v-if="roomExist || cadMapExist">
        <el-tabs
          v-model="activeTab"
          class="tab-primary"
          type="card"
          @tab-click="onTabClick">
          <el-tab-pane
            label="构件"
            name="element">
            <BimElemTree
              ref="bimElemTree"
              :isShareDataSet="false"
              :dataSetId="dataSetId"
              :isShowRvtGroup="isShowRvtGroup"
              :bimElemTreeRootData="dataSetTreeData" />
          </el-tab-pane>
          <el-tab-pane
            label="房间和面积"
            name="room"
            v-if="roomExist">
            <div class="common-tree-box">
              <el-tree
                class="dialog-tree-small-primary"
                ref="roomTree"
                :data="roomTreeData"
                :props="defaultRoomProps"
                :default-expanded-keys="['1']"
                node-key="nodeId"
                highlight-current
                :expand-on-click-node="false"
                @node-click="handleRoomNodeClick">
                <div
                  slot-scope="{ data }"
                  class="node-label text-overflow"
                  :title="data.nodeName">
                  {{ data.nodeName }}
                </div>
              </el-tree>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="图纸"
            name="cad"
            v-if="cadMapExist">
            <div class="common-tree-box">
              <el-tree
                class="dialog-tree-small-primary"
                ref="cadMapTree"
                :data="cadMapTreeData"
                :props="defaultProps"
                :default-expanded-keys="cadMapTreeExpanded"
                node-key="nodeId"
                highlight-current
                :expand-on-click-node="false"
                @node-click="handleCadNodeClick">
                <div
                  slot-scope="{ data }"
                  class="node-label text-overflow"
                  :title="data.name">
                  {{ data.name }}
                </div>
              </el-tree>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <BimElemTree
        v-else
        ref="bimElemTree"
        :isShareDataSet="false"
        :dataSetId="dataSetId"
        :isShowRvtGroup="isShowRvtGroup"
        :bimElemTreeRootData="dataSetTreeData" />
    </div>
    <div
      class="bottom-option-box"
      v-if="isOptionVisible">
      <el-checkbox
        class="checkbox-primary"
        v-model="isShowRvtGroup">
        Group目录树
      </el-checkbox>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
import BimElemTree from './BimElemTree.vue'
import { getParentNode } from '@/utils/generalMethods'

import {
  getProjectTree,
  isRoomExistService,
  getRoomList,
  getRoomInfo,
  getRoomElement,
  isCadMapExistService,
  getCadMapList,
  getElemTreePath
} from '@/service/interface'

export default {
  data() {
    return {
      roomExist: false,
      cadMapExist: false,
      activeTab: 'element',

      dataSetId: '',
      formatType: 1,
      dataSetTreeData: [],
      defaultProps: {
        children: 'nodes',
        label: 'name'
      },

      roomTreeData: [],
      defaultRoomProps: {
        children: 'nodes',
        label: 'nodeName'
      },

      cadMapTreeData: [],
      cadMapTreeExpanded: [],

      isShowRvtGroup: false
    }
  },
  props: {
    limitDragArea: String,
    closePanel: Function,
    toggleViewAngleBtn: Function,
    resetViewAngle: Function,
    updateAttributeType: Function,
    updateAttributeData: Function,
    loadBIMCAD: Function,
    resetElemAttr: Function,
    showRoom: Function,
    setCanvasViewMode: Function,
    closeCadLayerPanel: Function,
    closeCadLayoutPanel: Function
  },
  components: {
    DragPanel,
    BimElemTree
  },
  computed: {
    isOptionVisible: function () {
      const rootNode = this.dataSetTreeData[0]
      let visible = false
      if (this.formatType === 1) {
        visible = rootNode?.hasRvtGroup
      } else {
        const files = rootNode ? rootNode.files : []
        visible = files.some(el => el.hasRvtGroup)
      }

      return visible
    }
  },
  created() {
    let dataType = this.$route.query.dataType
    if (dataType === 'Bim') {
      this.initCatalogTree().then(() => {
        this.initRoomTree().then(() => {
          this.initCadMapTree().then(() => {
            this.$refs.bimElemTree?.initBimElemTreeData()
          })
        })
      })
    }
  },
  methods: {
    initCatalogTree() {
      return new Promise(resolve => {
        let dataSetId = this.$route.query.datasetId
        this.dataSetId = dataSetId
        getProjectTree({ dataSetId }).then(response => {
          if (response.isSuccess) {
            let dataSets = response.data

            let formatType = dataSets[0].formatType
            this.formatType = formatType

            let treeData = this.formatDataSetData(dataSets)
            this.dataSetTreeData = treeData
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    initRoomTree() {
      return new Promise(resolve => {
        this.isRoomExist().then(roomExist => {
          if (!roomExist) {
            this.roomExist = false
            this.roomTreeData = []
            resolve()
            return
          }

          let datasetId = this.$route.query.datasetId
          let fileNames = this.getRoomFilesName()
          let params = {
            dataSetId: datasetId,
            fileNames
          }

          getRoomList(params).then(response => {
            if (response.isSuccess) {
              let data = response.data
              data = data.filter(item => {
                let rooms = item.rooms
                if (rooms[0] && item.elementIntIds) {
                  return true
                } else {
                  return false
                }
              })
              let roomTreeData = data.map(item => {
                item['nodeName'] = item.hostFileName
                item['nodeId'] = item.hostFileId
                item['nodes'] = item.rooms
                return item
              })
              if (roomTreeData.length) {
                this.roomExist = true
                this.roomTreeData = roomTreeData
              } else {
                this.roomExist = false
              }
              resolve()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
      })
    },
    initCadMapTree() {
      return new Promise(resolve => {
        this.isCadMapExist().then(cadMapExist => {
          if (!cadMapExist) {
            this.cadMapExist = false
            this.cadMapTreeData = []
            resolve()
            return
          }
        })

        let datasetId = this.$route.query.datasetId
        let fileNames = this.getRoomFilesName()
        let params = {
          dataSetId: datasetId,
          fileNames,
          showMaps: false
        }
        getCadMapList(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            if (data.length) {
              this.cadMapExist = true

              let cadMapTreeData = this.formatCadMapData(data)
              this.cadMapTreeData = cadMapTreeData
              let defaultData = cadMapTreeData[0]
              this.cadMapTreeExpanded.push(defaultData.nodeId)
              this.$nextTick(() => {
                if (defaultData.nodes && defaultData.nodes.length) {
                  let currKey = defaultData.nodes[0].nodeId
                  this.$refs.cadMapTree.setCurrentKey(currKey)
                }
              })
            } else {
              this.cadMapExist = false
            }
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    onTabClick(tab) {
      if (tab.name === 'element') {
        this.setCanvasViewMode('model')
        this.closeCadLayerPanel()
        this.closeCadLayoutPanel()
        window.BlackHole3D.Clip.endClip()
        this.updateAttributeType('element')
        this.toggleViewAngleBtn(true)
        this.resetViewAngle()
        window.BlackHole3D.Graphics.setSysUIPanelVisible(true)
        window.BlackHole3D.Graphics.setGeoCoordVisible(true)
        window.BlackHole3D.Graphics.setViewCubeVisible(true)

        window.BlackHole3D.setViewMode(
          window.BlackHole3D.REVpTypeEm.BIM,
          window.BlackHole3D.REVpTypeEm.None,
          window.BlackHole3D.REVpRankEm.Single
        )

        this.resetElemAttr()
      }
      if (tab.name === 'room') {
        this.setCanvasViewMode('model')
        this.closeCadLayerPanel()
        this.closeCadLayoutPanel()
        this.updateAttributeType('room')
        this.toggleViewAngleBtn(false)
        window.BlackHole3D.Graphics.setSysUIPanelVisible(true)
        window.BlackHole3D.Graphics.setGeoCoordVisible(true)
        window.BlackHole3D.Graphics.setViewCubeVisible(true)

        window.BlackHole3D.setViewMode(
          window.BlackHole3D.REVpTypeEm.BIM,
          window.BlackHole3D.REVpTypeEm.None,
          window.BlackHole3D.REVpRankEm.Single
        )
      }
      if (tab.name === 'cad') {
        this.setCanvasViewMode('bimCad')
        this.toggleViewAngleBtn(false)
        if (!this.cadMapTreeData.length) {
          this.initCadMapTree().then(() => {
            if (this.cadMapTreeData.length) {
              let cadInfo = this.cadMapTreeData[0].nodes[0]
              cadInfo.hostFileId = this.cadMapTreeData[0].hostFileId
              // 加载二维图纸
              this.loadBIMCAD(cadInfo)
            }
          })
        } else {
          let cadInfo = this.cadMapTreeData[0].nodes[0]
          cadInfo.hostFileId = this.cadMapTreeData[0].hostFileId
          // 加载二维图纸
          this.loadBIMCAD(cadInfo)
          this.$refs.cadMapTree.setCurrentKey(cadInfo.nodeId)
        }
      }
    },
    handleRoomNodeClick(nodeData, node) {
      if (!node.isLeaf) return

      let dataSetId = this.$route.query.datasetId
      let params = {
        dataSetId,
        childNodeId: nodeData.nodeId
      }
      getRoomElement(params)
        .then(response => {
          if (response.isSuccess) {
            let data = response.data
            let childNodeIds = data.elemIntIds
            if (childNodeIds.length) {
              return Promise.resolve(childNodeIds)
            } else {
              return Promise.resolve([])
            }
          }
        })
        .then(childNodeIds => {
          let params2 = {
            dataSetId,
            elementIntId: ''
          }
          if (childNodeIds.length) {
            params2['elementIntId'] = childNodeIds[0] + ''
          }
          getRoomInfo(params2).then(res => {
            if (res.isSuccess) {
              let attributeData = res.data
              let roomInfo = {}
              attributeData.forEach(item => {
                item['paramGroup'] = item.roomParamGroup
                item.roomParams.forEach(obj => {
                  if (obj.roomParamName === 'LevelBottom') {
                    roomInfo['levelHeightBottom'] = obj.roomParamValue
                  }
                  if (obj.roomParamName === 'LevelTop') {
                    roomInfo['levelHeightTop'] = obj.roomParamValue
                  }

                  obj['paramName'] = obj.roomParamName
                  obj['paramValue'] = obj.roomParamValue
                  obj['paramType'] = obj.roomParamType
                })

                item['paramDatas'] = item.roomParams
              })

              roomInfo['elemIntIds'] = childNodeIds
              this.showRoom(roomInfo)
              this.updateAttributeData(attributeData)
            }
          })
        })
    },
    handleCadNodeClick(nodeData) {
      if (nodeData.customType && nodeData.customType === 'cadParent') return
      nodeData.hostFileId = this.cadMapTreeData[0].hostFileId
      this.loadBIMCAD(nodeData)
    },
    // 目录树未完全展开时，展开指定节点
    expandNodes(nodeIds) {
      // return new Promise((resolve) => {
      // });
      // let nodeIds = [1, 570, 576, 578];
    },
    locationTreeNodeByElemId(elementId) {
      let dataSetId = this.$route.query.datasetId
      let params = {
        dataSetId: dataSetId,
        elementIntId: elementId
      }
      getElemTreePath(params).then(response => {
        if (response.isSuccess) {
          let nodeIds = response.data
          let nodeId = nodeIds.pop() + ''
          let nodeData = this.findNodeById(this.dataSetTreeData, nodeId)

          let node = this.$refs.dataSetTree.getNode(nodeData.uniqueId)
          let parentNodes = []
          this.getParentNode(node, parentNodes)
          parentNodes.forEach(item => {
            item.expanded = true
            item.checked = true
            item.childNodes.forEach(node => {
              node.checked = true
            })
          })

          this.$nextTick(() => {
            this.$refs.dataSetTree.setCurrentKey(nodeData.uniqueId)
            this.scrollToNode(nodeData)
          })
        }
      })
    },
    scrollToNode(nodeData) {
      let dom = this.$refs.dataSetTree.$el.childNodes[0]
      let element = dom.querySelector(`[dataNodeId="${nodeData.uniqueId}"]`)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        })
      } else {
        const deltaScrollDis = dom.scrollHeight / 4
        let timer = setInterval(() => {
          element = dom.querySelector(`[dataNodeId="${nodeData.uniqueId}"]`)
          if (element) {
            clearInterval(timer)
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest'
            })
            return
          } else {
            dom.scrollTo({
              top: dom.scrollTop + deltaScrollDis,
              behavior: 'smooth'
            })
          }

          if (dom.scrollTop >= dom.scrollHeight - dom.clientHeight) {
            dom.scrollTop = 0
          }
        }, 1500)
      }
    },
    /**
     * 获取带有房间信息的文件名
     */
    getRoomFilesName() {
      // 带有房间和图纸信息的模型来源(根据srcCatalog字段判断来源)
      const FileSrcWithRoomInfo = [0, 1, 4]

      let pakNodeDatas = []
      if (this.formatType === 1) {
        pakNodeDatas = this.dataSetTreeData
      } else {
        pakNodeDatas = this.dataSetTreeData[0].nodes
      }
      let roomFiles = pakNodeDatas.filter(el =>
        FileSrcWithRoomInfo.includes(el.srcCatalog)
      )
      let roomFilesName = roomFiles.map(item => {
        return item.name
      })
      return roomFilesName
    },
    formatDataSetData(dataSets) {
      const formatType = dataSets[0]?.formatType
      let treeData = []
      if (formatType === 1) {
        treeData = dataSets[0].files
        treeData.forEach(item => {
          item['customNodeType'] = 'dataSet'
          item['formatType'] = formatType
          item['name'] = item.fileName
          item['dataSetId'] = dataSets[0].dataSetId
          item['dataSetType'] = dataSets[0].dataSetType
          item.nodes = [{ name: '' }]
        })
      }
      if (formatType === 2) {
        dataSets.forEach(item => {
          item['customNodeType'] = 'dataSet'
          item['name'] = item.dataSetName
          item.nodes = item.files
          item.nodes.forEach(node => {
            node['customNodeType'] = 'file'
            node['name'] = node.fileName
            node.nodes = [{ name: '' }]
          })
        })
        treeData = dataSets
      }
      return treeData
    },
    formatCadMapData(data) {
      data.forEach(item => {
        item['customType'] = 'cadParent'
        item.nodes = item.sheets
        item.name = item.hostFileName
        item.nodeId = item.hostFileId

        let nodes = item.nodes
        if (nodes.length) {
          nodes.forEach(sheet => {
            sheet['nodeId'] = sheet.cadSheetId
            sheet['name'] = sheet.cadSheetName
            sheet['nodes'] = []
          })
        }
      })
      return data
    },
    isRoomExist() {
      return new Promise(resolve => {
        let dataSetId = this.$route.query.datasetId
        isRoomExistService({ dataSetId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            resolve(data.exist)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    isCadMapExist() {
      return new Promise(resolve => {
        let dataSetId = this.$route.query.datasetId
        isCadMapExistService({ dataSetId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            resolve(data.exist)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    findNodeById(data, nodeId) {
      for (const node of data) {
        if (node.nodeId === nodeId) return node
        if (node.nodes && node.nodes.length) {
          const res = this.findNodeById(node.nodes, nodeId)
          if (res) return res
        }
      }
      return null
    },
    getParentNode
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  top: 60px;
  left: 10px;
  width: 290px;
  min-width: 290px;
  height: calc(100% - 125px);
  border-radius: 8px;

  :deep(.content) {
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);

    .catalog-tree-box {
      flex-grow: 1;
      min-height: 0;
      text-align: left;

      .common-tree-box {
        height: 100%;
        padding: 8px 10px;

        .dialog-tree-small-primary {
          & > .el-tree-node > .el-tree-node__content {
            height: 24px;
          }
        }

        .el-tree-node__content {
          .el-checkbox {
            margin-bottom: 3px;
          }
        }

        .dialog-tree-primary > .el-tree-node > .el-tree-node__children {
          .el-checkbox {
            margin-right: 0;
          }
        }

        .node-label {
          font-size: 14px;
        }

        .el-tree {
          .el-tree-node > .el-tree-node__children {
            .node-label {
              padding-left: 6px;
            }
          }
        }
      }

      .common-card-tabs-box {
        height: calc(100% - 5px);
        margin-top: 16px;
        .el-tabs {
          height: 100%;

          .el-tabs__nav {
            margin-left: 15px;
          }

          .el-tabs__item {
            padding: 0 16px;
          }

          .el-tabs__content {
            margin-top: 0px;

            .el-tab-pane {
              height: 100%;
            }
          }
        }
        .el-tabs__header {
          .el-tabs__item {
            color: var(--eng-tab-text-color);
            border: 1px solid var(--eng-tab-border-color) !important;
            background-color: var(--eng-tab-bgColor);

            &:hover {
              background-color: var(--eng-tab-hover-bgColor);
              border: 1px solid transparent !important;
            }
            &.is-active {
              border-color: transparent !important;
            }
          }
        }
      }
    }

    .bottom-option-box {
      padding: 10px;
      text-align: left;
      border-top: 1px solid var(--dialog-split-line-color);

      .checkbox-primary {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
